module.exports = __webpack_public_path__ + "static/media/AboutJumboImg.33a0c37a.png";